"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCurrentPlayer = exports.isPlayersTurn = exports.update = exports.reset = exports.resetStillness = exports.get = exports.MinigolfControlScheme = exports.MinigolfGameStates = void 0;
// import { crokinoleGamepadCursors } from '@crokinole/cursors/crokinoleGamepadCursors-sidecar'
// import { crokinoleUi_menu_players } from '@crokinole/ui-menus/crokinoleUi_menu_players-sidecar'
var assert_sidecar_1 = require("@lib/assert-sidecar");
var minigolfDefs_sidecar_1 = require("../defs/minigolfDefs-sidecar");
// import { CrokinoleBoardPosition } from './crokinoleDefs'
// import { crokinoleDefs } from './crokinoleDefs-sidecar'
var namespace = 'crokinole_board';
exports.MinigolfGameStates = {
    gameStart: 0,
    levelGen: 1,
    waitForPlayerFling: 2,
    waitForPlayerSettle: 3,
    enemyTurn: 4,
    waitForEnemySettle: 5,
};
exports.MinigolfControlScheme = {
    mouse: 0,
    gamepad: 1,
};
var _obj = null;
function get() {
    if (!_obj) {
        create();
        exports.reset();
    }
    assert_sidecar_1.assert.notNil(_obj);
    return _obj;
}
exports.get = get;
var create = function () {
    var obj = {
        state: exports.MinigolfGameStates.gameStart,
        currentPuck: null,
        allStillTime: 0,
        isAllStill: false,
        map: null,
        playerState: {
            food: 0,
            health: 0,
            dungeonLevel: 0,
            hasAmulet: false,
            didWin: false,
            didLose: false,
            lastDamage: '',
            deathReason: '',
            gameStateString: '',
            isDungeonBroken: false,
            isDungeonLocked: false,
            keys: 0,
            attackPower: 1,
            levelPar: 0,
            money: 0,
            difficulty: '',
            killedList: '',
        },
    };
    _obj = obj;
};
var resetStillness = function () {
    var obj = get();
    obj.allStillTime = 0;
    obj.isAllStill = false;
};
exports.resetStillness = resetStillness;
var reset = function () {
    var obj = get();
    obj.currentPuck = null;
    obj.state = exports.MinigolfGameStates.gameStart;
    exports.resetStillness();
    obj.playerState.food = 3;
    obj.playerState.health = 6;
    obj.playerState.dungeonLevel = minigolfDefs_sidecar_1.minigolfDefs.debug_startLevel;
    obj.playerState.hasAmulet = false;
    obj.playerState.didWin = false;
    obj.playerState.didLose = false;
    obj.playerState.lastDamage = 'unknown';
    obj.playerState.deathReason = 'unknown';
    obj.playerState.keys = 0;
    obj.playerState.attackPower = 1;
    obj.playerState.isDungeonBroken = false;
    obj.playerState.isDungeonLocked = false;
    obj.playerState.levelPar = 0;
    obj.playerState.difficulty = '';
    obj.playerState.money = 0;
    obj.playerState.killedList = '';
    // TODO: other resets
    // crokinoleGamepadCursors.reset()
    // createPlayersFromPlayersMenu()
    // resetCurrentPlayerGamepadXY()
};
exports.reset = reset;
// export const resetCurrentPlayerGamepadXY = () => {
//   let offset = 2.5
//   let obj = get()
//   let cp = getCurrentPlayer()
//   let pp = getCrokinolePlayerPosition(cp)
//   if (cp.gamepadNum > -1) {
//     let gp = crokinoleGamepadCursors.getByGamepadNumber(cp.gamepadNum)
//     if (gp) {
//       crokinoleGamepadCursors.moveToXY(
//         gp,
//         pp.quadrantOffsetX * offset,
//         pp.quadrantOffsetY * offset,
//       )
//     }
//   }
//   // obj.gamepadX = pp.quadrantOffsetX * offset
//   // obj.gamepadY = pp.quadrantOffsetY * offset
// }
// export const getCurrentPlayer = () => {
//   let obj = get()
//   return getPlayer(obj.currentPlayerNum)
// }
// export const getPlayer = (playerNum: number) => {
//   let obj = get()
//   return obj.players[playerNum]
// }
var update = function () { };
exports.update = update;
// export const advanceState = () => {
//   let obj = get()
//   obj.allStillTime = 0
//   obj.isAllStill = false
var isPlayersTurn = function () {
    var obj = get();
    return (obj.state === exports.MinigolfGameStates.waitForPlayerFling ||
        obj.state === exports.MinigolfGameStates.waitForPlayerSettle);
};
exports.isPlayersTurn = isPlayersTurn;
var getCurrentPlayer = function () {
    var obj = get();
    var puck = obj.currentPuck;
    if (!puck || puck.isDead) {
        return null;
    }
    return puck;
};
exports.getCurrentPlayer = getCurrentPlayer;
